import type { SessionState } from "@common/services/realtime/realtime-service";
import type { RealtimeService } from "@common/services/realtime/realtime-service";
import { makeAutoObservable, observable, runInAction } from "mobx";

export default class RealtimeSessionStore {
  @observable
  state: SessionState | undefined;

  constructor(
    private deps: {
      realtimeService: RealtimeService;
    }
  ) {
    makeAutoObservable(this);
  }

  connect() {
    // Make sure multiple calls don't result in multiple subscriptions
    this.cleanup();

    this.deps.realtimeService.connect();
    this.deps.realtimeService.eventEmitter.on("session.updated", (state) => {
      runInAction(() => {
        this.state = state;
      });
    });

    this.deps.realtimeService.eventEmitter.on("session.patched", (delta) => {
      console.log("** Realtime: session patched", delta);
      runInAction(() => {
        this.state = { ...this.state, ...delta };
      });
    });
  }

  cleanup() {
    this.deps.realtimeService.cleanup();
    this.deps.realtimeService.eventEmitter.removeAllListeners();
  }

  patch(delta: Partial<SessionState>) {
    this.deps.realtimeService.patchState(delta);
  }

  update(state: SessionState) {
    this.deps.realtimeService.updateState(state);
  }
}
